import {
  Button,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Stack } from "@mui/material";
import DateField from "components/CustomFields/DateField";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { getCurrentDate } from "utils/dateGetters.js";
import { dbGet } from "utils/DBFetchers";

import useStyles from "./styles";

const FIRST_MONTH = new Date(getCurrentDate().getFullYear(), 0, 1);
const GENERAL_PANEL_DOCUMENTATION_LINK =
  "https://cfr-config.s3.sa-east-1.amazonaws.com/cfr_rules_documentation/definiciones_panel_general_quemables.pdf";

const LAST_MONTH = new Date(
  getCurrentDate().getFullYear(),
  getCurrentDate().getMonth(),
  1,
);

const getDateFormatted = (date) => {
  return format(date, "yyyy/MM");
};

const ConditionalFiltersSelection = {
  NONE: null,
  BRAND: 'brand',
  PRESENTATION: 'presentation',
  BUSSINESSAREA: 'bussinessarea',
};

const FILTERS = {
  fromDate: getCurrentDate(),
  toDate: getCurrentDate(),
  vademecum_valid: false,
  canal: null,
  brand: null,
  presentation: null,
  bussinessArea: null,
  canal: null,
};

const SELECT_INFORMATION = {
  brands: [],
  presentations: [],
  bussinessAreas: [],
};

export const GeneralBurnableSelectionForm = (props) => {
  var classes = useStyles();

  const [filters, setFilters] = useState(FILTERS);
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [selectInformation, setSelectInformation] = useState(SELECT_INFORMATION);
  const [SelectedConditionalFilters, setSelectedConditionalFilters] = useState(ConditionalFiltersSelection.NONE);

  const handleFilterChange = (filter, value) => {
    setFilters({
      ...filters,
      [filter]: value,
    });
  };

  const handleFromPeriodChange = (date) => {
    var dateOnFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    if (dateOnFirstDay > filters.toDate) {
      snackbarOpen("error", "El período final no puede ser menor al inicial");
      return;
    }
    setFilters({
      ...filters,
      fromDate: dateOnFirstDay,
    });
  };

  const handleToPeriodChange = (date) => {
    var dateOnFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    if (dateOnFirstDay < filters.fromDate) {
      snackbarOpen("error", "El período final no puede ser menor al inicial");
      return;
    }
    setFilters({
      ...filters,
      toDate: dateOnFirstDay,
    });
  };

  const handleVademecumChange = (event) => {
    handleFilterChange("vademecum_valid", event.target.value === "true");
  };

  const handleCanalChange = (event, newValue) => {
    handleFilterChange("canal", newValue);
  };

  const handleBrandChange = (event, newValue) => {
    handleFilterChange("brand", newValue);
    handleConditionalFilters(newValue, ConditionalFiltersSelection.BRAND);
  };
  
  const handlePresentationChange = (event, newValue) => {
    handleFilterChange("presentation", newValue);
    handleConditionalFilters(newValue, ConditionalFiltersSelection.PRESENTATION);
  };
  
  const handleBussinessAreaChange = (event, newValue) => {
    handleFilterChange("businessArea", newValue);
    handleConditionalFilters(newValue, ConditionalFiltersSelection.BUSSINESSAREA);
  };

  const handleConditionalFilters = (newValue, conditionalFilter) => {
    if (!newValue) {
      setSelectedConditionalFilters(ConditionalFiltersSelection.NONE);
    } else {
      setSelectedConditionalFilters(conditionalFilter);
    }
  };

  const getFiltersContent = () => {
    Promise.all([
      dbGet("presentations/bussiness_areas"),
      dbGet("presentations/brands?only_burnable_brands=true"),
      dbGet("presentations/burnable/1000"),
    ])
      .then(([bussinessAreas, brands, presentations]) => {
        setSelectInformation({
          bussinessAreas,
          brands,
          presentations,
        });
      })
      .catch((error) => {
        snackbarOpen("error", "Error al obtener los datos");
      });
  };

  const checkRequiredParams = (onApplyFiltersFunc) => {
    onApplyFiltersFunc(filters);  // no mandatory fields to check
  };

  useEffect(() => {
    getFiltersContent();
  }, []);

  return (
    <>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Grid
        item
        xs={12}
        lg={12}
        style={{ marginBottom: "10px", marginLeft: "2.5%" }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography variant="h4" className={classes.alignedText}>
            Selección
          </Typography>
          <Button
            component="a"
            href={GENERAL_PANEL_DOCUMENTATION_LINK}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            variant="text"
          >
            Ver Documentación
          </Button>
        </Grid>
        <Divider />
      </Grid>

      <Grid container justifyContent="center" spacing={1}>
        {/* Fila 1 */}
        <Grid item container xs={12} justifyContent="center">
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography className={classes.alignedText} weight="bold">
                Período inicial
              </Typography>
            </Grid>
            <Grid item xs={9} className={classes.alignLeft}>
              <DateField
                views={["year", "month"]}
                minDate={new Date("2013-10-01")}
                maxDate={getCurrentDate()}
                format={"MM/yyyy"}
                value={filters.fromDate}
                onChange={handleFromPeriodChange}
                fieldClassName={classes.dateSelectionField}
              />
            </Grid>
          </Grid>

          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography className={classes.alignedText} weight="bold">
                Período final
              </Typography>
            </Grid>
            <Grid item xs={9} className={classes.alignLeft}>
              <DateField
                views={["year", "month"]}
                minDate={new Date("2013-10-01")}
                maxDate={getCurrentDate()}
                format={"MM/yyyy"}
                value={filters.toDate}
                onChange={handleToPeriodChange}
                fieldClassName={classes.dateSelectionField}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Fila 2 */}
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          style={{ marginTop: "5px" }}
        >
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Canal
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="brand"
                autoHighlight
                onChange={handleCanalChange}
                options={["Cadenas", "Independientes"]}
                getOptionLabel={(option) => option}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
          
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Marca
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="brand"
                autoHighlight
                onChange={handleBrandChange}
                disabled={SelectedConditionalFilters && (SelectedConditionalFilters !== ConditionalFiltersSelection.BRAND)}
                options={selectInformation.brands || []}
                getOptionLabel={(option) => option}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Fila 3 */}
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          style={{ marginTop: "5px" }}
        >
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Presentación
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="presentation"
                autoHighlight
                onChange={handlePresentationChange}
                disabled={SelectedConditionalFilters && (SelectedConditionalFilters !== ConditionalFiltersSelection.PRESENTATION)}
                options={selectInformation.presentations || []}
                getOptionLabel={(option) => option.name}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
          
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Área de negocio
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="bussinessArea"
                autoHighlight
                onChange={handleBussinessAreaChange}
                disabled={SelectedConditionalFilters && (SelectedConditionalFilters !== ConditionalFiltersSelection.BUSSINESSAREA)}
                options={selectInformation.bussinessAreas || []}
                getOptionLabel={(option) => option}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Fila 4 */}
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          style={{ marginTop: "5px" }}
        >
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Vademecum
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <RadioGroup
                row
                name="vademecum"
                defaultValue="false"
                value={filters.vademecum_valid ? "true" : "false"}
                onChange={handleVademecumChange}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" />}
                  label="Vigente"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" />}
                  label="Histórico"
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Grid item container xs={4} />
        </Grid>

        <Grid
          item
          xs={12}
          style={{ marginTop: "20px", marginBottom: "10px" }}
          spacing={2}
          className={classes.uploadButton}
        >
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                // props.onApplyFilters(filters);
                checkRequiredParams(props.onApplyFilters);
              }}
            >
              Aplicar
            </Button>
            <Button
              disabled={props.isLoading || !props.canDownload}
              variant="contained"
              color="secondary"
              onClick={props.exportFunction}
            >
              Descargar
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};
